import type { DocumentPickerAsset } from "expo-document-picker";

import * as DocumentPicker from "expo-document-picker";
import { useCallback, useState } from "react";

const DOCUMENT_MIME_TYPES = [
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export function useFilePicker() {
  const [file, setFile] = useState<DocumentPickerAsset | null>(null);
  const [error, setError] = useState<Error | null>(null);

  const pickFile = useCallback(async (): Promise<boolean> => {
    try {
      const result = await DocumentPicker.getDocumentAsync({
        type: DOCUMENT_MIME_TYPES,
        copyToCacheDirectory: true,
        multiple: false,
      });

      if (result.canceled || !result.assets?.[0]) {
        return false;
      }

      const asset = result.assets[0];

      if (!asset.name || asset.size === undefined) {
        return false;
      }

      setFile(asset);
      return true;
    } catch (e) {
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
      setError(e as Error);
      return false;
    }
  }, []);

  const clearFile = useCallback(() => {
    setFile(null);
    setError(null);
  }, []);

  return {
    pickFile,
    file,
    clearFile,
    error,
  };
}
